import { navegar } from '../hooks/useRuta'

/**
 * `<a>` consciente del enrutador: navega sin recarga cuando el destino es
 * otra ruta interna, pero deja que el navegador maneje de forma nativa los
 * clics en anclas dentro de la misma ruta (p. ej. "/#catalogo" pulsado ya
 * estando en "/"), que es justo el desplazamiento suave que ya existía.
 * Ctrl/Cmd/clic central siguen abriendo en pestaña nueva porque no se
 * interceptan.
 */
function Enlace({ href, onClick, children, ...props }) {
  function alHacerClick(evento) {
    onClick?.(evento)
    if (evento.defaultPrevented) return
    if (evento.button !== 0 || evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) {
      return
    }

    let destino
    try {
      destino = new URL(href, window.location.href)
    } catch {
      return
    }
    if (destino.origin !== window.location.origin) return

    const mismaRuta = destino.pathname === window.location.pathname
    if (mismaRuta && destino.hash) return // ancla nativa, sin recarga

    evento.preventDefault()

    if (mismaRuta) {
      window.scrollTo({ top: 0, behavior: 'instant' })
      return
    }

    navegar(destino.pathname + destino.search + destino.hash)

    // pushState no mueve el scroll (a diferencia de una navegación real): sin
    // esto, ir desde el catálogo ya desplazado hasta el detalle de un
    // producto aterriza a mitad de la página nueva. Si hay hash, es
    // useAnclaInicial quien decide a dónde saltar.
    if (!destino.hash) window.scrollTo({ top: 0, behavior: 'instant' })
  }

  return (
    <a href={href} onClick={alHacerClick} {...props}>
      {children}
    </a>
  )
}

export default Enlace
